<!-- @format -->

<paid-summary-tag>

	<div class="container_contents">

		<div class="container_breadcrumb">
			<ul class="breadcrumb">
				<li class="breadcrumb-item"><span class="heading-01 heading_orders">受注履歴・請求関連</span></li>
				<li class="breadcrumb-item">支払調書</li>
			</ul>
		</div><!--/.container_breadcrumb-->

		<div class="contents">

			<div class="tab-menu margin-spacing-4_bottom">
				<ul class="tab-menu-list">
					<li class="tab-menu-list-item">
						<a href="/project/history">受注履歴と確定報酬一覧</a>
					</li>
					<li class="tab-menu-list-item is-active">
						<a href="/project/paid-summary">支払調書</a>
					</li>
				</ul>
			</div>

			<section class="contents_area">

				<p class="text">指定された年にクライアント様から受注したプロジェクトの一覧を表示しています</p>
				<p class="text margin-spacing-4_bottom">また、クライアント様より届いた「マイナンバーの閲覧申請」の一覧は<a href="/menu/mynumber-browsing-application">こちら</a>からご確認下さい。</p>

				<div class="contents_block margin-spacing-3_top">
					<form>

						<div class="wrap_input wrap_input-30 margin-spacing-3_bottom">
							<label class="form-heading">
								対象年
							</label>
							<select name="target_year" id="target_year" class="sort-list" onchange={setTargetYear}>
								<option value="2021" selected="{(state.params.target_year == '2021')}">2021年</option>
								<option value="2022" selected="{(state.params.target_year == '2022')}">2022年</option>
							</select>
						</div>

						<div class="wrap_input wrap_input-30 margin-spacing-3_bottom">
							<label class="form-heading">
								対象クライアント名
							</label>
							<input type="text" class="text_input" name="target_client_name" value="{state.params.target_client_name}" onkeydown={checkKeyType} onkeyup={setClientName}>
						</div>

						<div class="wrap_input wrap_input-30 margin-spacing-4_bottom">
							<label class="form-heading">
								クライアントからの支払調書の郵送報告
							</label>
							<select name="target_mailing_request" id="target_mailing_request" class="sort-list" onchange={setMailingRequest}>
								<option value="all">全て</option>
								<option value="replied" selected="{(state.params.target_mailing_request == 'replied')}">あり</option>
								<option value="not_yet_replied" selected="{(state.params.target_mailing_request == 'not_yet_replied')}">なし</option>
							</select>
						</div>

						<button class="button button-secondary" type="button" value="入力内容で検索する" data-ol-has-click-handler=""
								onclick={clickSearchButton}
						>入力内容で検索する</button>
					</form>
				</div>

				<br>
				<br>

				<div class="contents_block table">
					<p class="text">
						{state.params.target_year}年度のクライアント様毎の受注状況の一覧を表示します。該当クライアント様は{state.summary_list.length}件です
					</p>
					<div>

						<table class="contents_table pay-detail_table margin-spacing-3_top">
							<tbody>
							<tr>
								<th>対象年</th>
								<th>クライアント名</th>
								<th>会社種類</th>
								<th>プロジェクト件数</th>
								<th>受注金額合計（税抜）</th>
								<th>消費税額合計</th>
								<th>源泉額合計</th>
								<th>受取額合計（税込）</th>
								<th>クライアントへの<br />支払調書の郵送依頼</th>
								<th style="width:17rem">クライアント様からの<br />支払調書の郵送報告</th>
								<th style="width:15rem">詳細ページへ</th>
							</tr>


							<tr each="{ summary in state.summary_list }">
								<td>{summary.target_year}年</td>
								<td>{summary.client_name}</td>
								<td>
									<span if={summary.company_type==1}>個人</span>
									<span if={summary.company_type==2}>法人</span>
								</td>
								<td><number-format number={summary.project_count}></number-format> 件</td>
								<td><number-format number={summary.sub_amount}></number-format>円</td>
								<td><number-format number={summary.tax}></number-format>円</td>
								<td>
									<span if={summary.company_type==1}>
										---
									</span>
									<span if={summary.company_type==2} style="color:red">
										<number-format number={summary.tax_withholding}></number-format>円
									</span>

								</td>
								<td style="gont-weight:bold"><number-format number={summary.amount}></number-format>円</td>
								<td>
									<span if={summary.mailing_request_state == 20 || summary.mailing_request_state == 30}>
									  郵送依頼済み
									</span>

									<div if={summary.mailing_request_state != 20 && summary.mailing_request_state != 30}
										class="button button-secondary-mini"
										 summary={summary}
										 onclick={e => clickMailRequestButton(summary.client_id,summary.client_name)}
									>
										郵送依頼をする
									</div>

								</td>
								<td>
									<div if={summary.mailing_request_state == 20}>
										なし
									</div>
									<span if={summary.mailing_request_state == 30}>
									  あり
									</span>
								</td>
								<td>
									<div class="button button-secondary-mini" summary={summary} onclick={gotoDetailPage}>
										詳細ページへ
									</div>
								</td>

							</tr>

							</tbody>
						</table>

					</div>
				</div>
			</section>

		</div>
	</div>

	<request-payment-record-modal-tag
			is-open="{ state.requestModalIsOpen }"
			on-close="{ e => { update({requestModalIsOpen: false}) } }"
			on-mail-request="{ onMailRequest }"
			target_year={state.params.target_year}
			client_id={state.target_client_id}
			client_name={state.target_client_name}
	></request-payment-record-modal-tag>

	<script>
		import di from "dependeny-injection";
		import requestPaymentRecordModal from "@tags/modal/project/paid-summary/request-payment-record-modal.riot";

		export default {
			components:{
				"request-payment-record-modal-tag" : requestPaymentRecordModal
			},
			api: false,
			state: {
				tabName: "orders",
				params: {
					target_year: 2021,
					target_client_name: "",
					target_mailing_request: "",
				},
				summary_list: [],
				target_client_id:null,
				target_client_name:null,
				requestModalIsOpen:false,
			},
			goTo(link){
				di.router.push(link);
			},
			onMounted(props, state) {
				//this.search.on("update:index", this.listenerUpdate);
			},
			onUnmounted(props, state) {
				//this.search.off("update:index", this.listenerUpdate);
				//this.search.isClear = true;
			},
			onBeforeMount(){
				let url = new URL(window.location.href);
				let params = url.searchParams;
				let target_year = params.get("target_year");

				if(target_year){
					this.state.params.target_year = target_year;
				}
				this.api = di.createApi('project');
				this.clickSearchButton();
			},
			gotoDetailPage(e){
				this.goTo("/project/paid-summary/detail/" + e.target.summary.target_year +"/" + e.target.summary.client_id);

			},
			async clickSearchButton(){
				const res = await this.api.request(
						"paid-summary",
						"fetch-summary-list",
						this.state.params
				);
				this.update({ summary_list: res });

			},
			clickMailRequestButton(client_id,client_name){
				this.update({
					target_client_id: client_id,
					target_client_name: client_name,
					requestModalIsOpen : true
				});
			},
			onMailRequest(){
				this.update({
					requestModalIsOpen : false
				});
				this.clickSearchButton();
			},
			setTargetYear(e){
				this.state.params.target_year = e.target.value;
			},
			checkKeyType(e){

				if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
					e.preventDefault();
					this.setClientName(e);
					this.clickSearchButton();
					return false;
				}

				return true;
			},
			setClientName(e){
				this.state.params.target_client_name = e.target.value;
			},
			setMailingRequest(e){
				this.state.params.target_mailing_request = e.target.value;
			}
		}
	</script>
</paid-summary-tag>
